export default __webpack_public_path__ + "static/media/Eye_2_M_C5.8238eb05.svg";